import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";

const MONTHS = ["March 1", "March 4", "March 7", "March 15", "Marchy 19", "March 23", "March 25", "March 28", "March 31"];

const sourcingData = MONTHS.map((month, i) => ({
  month,
  linkedin: [600, 200, 800, 400, 950, 550, 700, 450, 850][i],
  facebook: [300, 600, 400, 700, 200, 650, 350, 750, 250][i],
  wuzzuf: [800, 300, 600, 250, 750, 400, 650, 300, 700][i],
  referral: [200, 700, 350, 850, 300, 800, 200, 600, 450][i],
  other: [100, 400, 550, 150, 600, 200, 500, 100, 550][i],
}));

const chartConfig = {
  linkedin: { label: "LinkedIn", color: "#076698" },
  facebook: { label: "Facebook", color: "#076698" },
  wuzzuf: { label: "Wuzzuf", color: "#076698" },
  referral: { label: "Referral", color: "#94A3B8" },
  other: { label: "Other", color: "#F59E0B" },
};

const LEGEND_ITEMS = [
  { key: "linkedin", label: "LinkedIn", color: "#076698" },
  { key: "facebook", label: "Facebook", color: "#4F9DBF" },
  { key: "wuzzuf", label: "Wuzzuf", color: "#076698" },
  { key: "referral", label: "Referral", color: "#94A3B8" },
  { key: "other", label: "Other", color: "#F59E0B" },
];

const Y_TICKS = [5, 10, 20, 1000];

const DashboardSourcingChart = () => (
  <div className="w-full">
    <div className="flex flex-wrap items-center gap-4 mb-4">
      {LEGEND_ITEMS.map((item) => (
        <span key={item.key} className="flex items-center gap-1.5 text-xs text-secondary-foreground">
          <span className="inline-block w-2 h-2 rounded-full" style={{ background: item.color }} />
          {item.label}
        </span>
      ))}
    </div>
    <ChartContainer config={chartConfig} className="h-[220px] w-full">
      <AreaChart data={sourcingData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
        <defs>
          {LEGEND_ITEMS.map((item) => (
            <linearGradient key={item.key} id={`grad-${item.key}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor={item.color} stopOpacity={0.25} />
              <stop offset="95%" stopColor={item.color} stopOpacity={0} />
            </linearGradient>
          ))}
        </defs>
        <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#EEF0F3" />
        <XAxis
          dataKey="month"
          tickLine={false}
          axisLine={false}
          tick={{ fill: "#94a3b8", fontSize: 10 }}
        />
        <YAxis
          tickLine={false}
          axisLine={false}
          tick={{ fill: "#94a3b8", fontSize: 10 }}
          ticks={Y_TICKS}
        />
        <ChartTooltip content={<ChartTooltipContent />} />
        {LEGEND_ITEMS.map((item) => (
          <Area
            key={item.key}
            type="basis"
            dataKey={item.key}
            stroke={item.color}
            strokeWidth={2}
            fill={`url(#grad-${item.key})`}
            dot={false}
            activeDot={{ r: 4, strokeWidth: 0 }}
          />
        ))}
      </AreaChart>
    </ChartContainer>
  </div>
);

export default DashboardSourcingChart;
